import {action} from "mobx";
import fileService from "../services/fileService";
import appStore from "./appStore";

class fileStore {
    @action upload = async params => {
        const resultOfRequest = await fileService.upload(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }

        return resultOfRequest.data;
    };
}

export default new fileStore();
